import type { HtmlToTextOptions } from "html-to-text";

import { convert } from "html-to-text";
import * as z from "zod";

export const MAX_TEXT_LENGTH = 10_000;

export const ignoreHrefOptions: HtmlToTextOptions = {
  selectors: [{ options: { ignoreHref: true }, selector: "a" }],
};

export function buildTooLongMessage(
  fieldLabel: string,
  excess: number,
): string {
  return `${fieldLabel} text is too long by ${excess} characters`;
}

export function tooLongTextRefine(
  fieldLabel: string,
  convertOptions?: HtmlToTextOptions,
  maxLength: number = MAX_TEXT_LENGTH,
): (value: string, ctx: z.RefinementCtx) => void {
  return (value: string, ctx: z.RefinementCtx) => {
    const length = convert(value, convertOptions).length;

    if (length > maxLength) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: buildTooLongMessage(fieldLabel, length - maxLength),
      });
    }
  };
}

export const REQUEST_DESCRIPTION_FIELD = {
  convertOptions: ignoreHrefOptions,
  label: "Request description",
  path: "briefCreatorSingle.requestDescriptionHTML",
} as const;

export const TEXTS_FOR_DESIGN_FIELD = {
  convertOptions: ignoreHrefOptions,
  label: "Text for design",
  path: "briefCreatorSingle.textsForDesignHTML",
} as const;

export const BRIEF_CREATOR_SINGLE_FIELDS = [
  REQUEST_DESCRIPTION_FIELD,
  TEXTS_FOR_DESIGN_FIELD,
] as const;
